import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Truck, Zap } from 'lucide-react';

const TopBar = ({ isVisible }) => {
  const [currentPromoIndex, setCurrentPromoIndex] = useState(0);

  const promos = [
    { icon: <Truck className="w-4 h-4" />, text: '✨ Envío GRATIS en pedidos +50€' },
    { icon: <Zap className="w-4 h-4" />, text: '🔥 Nuevos mangas cada semana' },
    { icon: <Sparkles className="w-4 h-4" />, text: '💫 -5% en toda la web' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPromoIndex((prev) => (prev + 1) % promos.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [promos.length]);

  return (
    <motion.div
      initial={{ height: 40, opacity: 1 }}
      animate={{
        height: isVisible ? 40 : 0,
        opacity: isVisible ? 1 : 0
      }}
      transition={{ duration: 0.3 }}
      className="bg-muted/50 border-b border-border overflow-hidden"
    >
      <div className="container h-full flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentPromoIndex}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className="flex items-center gap-2 text-sm font-medium text-foreground"
          >
            {promos[currentPromoIndex].icon}
            <span>{promos[currentPromoIndex].text}</span>
          </motion.div>
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default TopBar;